<div class="dx-workflow-card bl-block-module bl-padding--16 bl-margin-bottom--16">
    <fieldset>
        <legend *ngIf="field.label" class="bl-font-size--14 bl-margin-bottom--16 bl-font-weight--800"
            [class.bl-required]="field.required || field.config.required"
            [class.bl-screen-reader-only]="screenReaderOnly(field)">
           <span class="bl-display--flex bl-align-items--center" [innerHTML]="field.label"></span>
        </legend>
        <div [ngClass]="formatter">
            <ng-container *ngFor="let nestedField of field.nestedFields">
                <cu-dynamic-field [page]="page" [card]="card" [field]="nestedField" [pageSubmitted$]="pageSubmitted$"
                    *ngIf="nestedField.visible"></cu-dynamic-field>
            </ng-container>
        </div>
    </fieldset>
</div>